import React from 'react';
import { Field } from '@progress/kendo-react-form';
import { CPS_CONTENT_TYPE_FIELD_TYPE } from '@cs-cms/types';
import { FormNumberInput } from '../../fields/FormNumberInput';
import { buildFieldValidators } from '../../validators/FormValidator';
import { getNumberFieldBounds, isFieldOptional } from '../fieldMapperHelpers';
import { FieldMapperContext } from '../fieldMapperTypes';

export function renderNumberField(ctx: FieldMapperContext): React.ReactElement {
  const { ctField, fieldLabel, fieldDisabled, handleChange, isLoading } = ctx;
  const { min, max } = getNumberFieldBounds(ctField.type);

  return (
    <Field
      key={ctField.name}
      name={ctField.name}
      component={FormNumberInput}
      label={fieldLabel}
      validator={buildFieldValidators(ctField)}
      optional={isFieldOptional(ctField)}
      isInteger={ctField.type !== CPS_CONTENT_TYPE_FIELD_TYPE.DECIMAL}
      hint={ctField.hint}
      min={ctField.min ?? min}
      max={ctField.max ?? max}
      onChange={handleChange}
      disabled={fieldDisabled}
      isLoading={isLoading}
    />
  );
}
